import React, { useEffect, useState } from "react";

function ScrollToTop() {
  const [progress, setProgress] = useState(307.919);
  const [visible, setVisible] = useState(false);
  const pathLength = 307.919;

  // 🔹 Your WhatsApp Number (country code ke saath)
  const whatsappNumber = "919876543210"; // <-- Apna number yaha daale

  useEffect(() => {
    const updateProgress = () => {
      const scroll = window.scrollY;
      const height =
        document.documentElement.scrollHeight - window.innerHeight;

      const progressValue =
        pathLength - (scroll * pathLength) / height;

      setProgress(progressValue);
      setVisible(scroll > 50);
    };

    window.addEventListener("scroll", updateProgress);
    return () => {
      window.removeEventListener("scroll", updateProgress);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      {/* 🔼 Scroll To Top */}
    

      {/* 💬 WhatsApp Button */}
     <a
  href="https://wa.me/917000117811"
  target="_blank"
  rel="noopener noreferrer"
  className="whatsapp-float"
>
  <i className="fab fa-whatsapp"></i>
</a>
    </>
  );
}

export default ScrollToTop;